(() => {
  const STORAGE_KEY = 'soundhousCompareV1';
  const FAMILY = 'architectural_speaker';
  const FAMILY_TITLE = 'Compare Architectural Speakers';
  const DEFAULT_TITLE = 'Compare products';

  const SCHEMA = [
    { label: 'Which is right for you?', rows: [
      ['decision.best_for','Best for'], ['decision.installation','Installation'], ['decision.sound_character','Sound character'],
      ['decision.room_fit','Soundhous room fit'], ['decision.listening_style','Listening style'], ['decision.visual_impact','Visual impact'],
      ['decision.key_advantage','Key advantage'], ['decision.key_compromise','Key compromise'],
      ['decision.soundhous_recommendation','Soundhous recommendation']
    ]},
    { label: 'Performance', rows: [
      ['performance.frequency_response','Frequency response'], ['performance.max_spl','Maximum SPL'], ['performance.coverage','Nominal coverage'],
      ['performance.sensitivity','Sensitivity'], ['performance.impedance','Impedance'], ['performance.power_handling','Power handling']
    ]},
    { label: 'Sonos system design', rows: [
      ['system.amp_requirement','Amplification'], ['system.amp_optimization','Sonos Architectural DSP'], ['system.trueplay','Trueplay'],
      ['system.speaker_capacity','Speaker capacity per Amp'], ['system.zone_note','Independent-zone note']
    ]},
    { label: 'Installation', rows: [
      ['installation.cutout','Cutout'], ['installation.depth','Mounting depth'], ['installation.grille_size','Visible grille / speaker size'],
      ['installation.dimensions','Dimensions'], ['installation.weight','Weight'], ['installation.grille','Grille'],
      ['installation.weather_rating','Weather rating'], ['installation.temperature_range','Operating temperature'],
      ['installation.mounting','Mounting'], ['installation.wire','Speaker cable']
    ]}
  ];

  const esc = (v) => String(v ?? '').replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#039;');
  const getPath = (o,p) => p.split('.').reduce((v,k) => v && Object.prototype.hasOwnProperty.call(v,k) ? v[k] : null,o);
  const norm = (v) => String(v ?? '').trim().replace(/\s+/g,' ').toLowerCase();
  const load = () => { try { const p=JSON.parse(localStorage.getItem(STORAGE_KEY)||'[]'); return Array.isArray(p)?p:[]; } catch(e){ return []; } };
  const selection = () => load().filter(i => i?.profile?.family === FAMILY);

  const render = (root) => {
    const chosen = selection();
    const title = root.querySelector('[id^="SoundhousCompareTitle-"]');
    const modal = root.querySelector('[data-shcmp-modal]');
    const tbody = root.querySelector('[data-shcmp-table] .shcmp-table tbody');
    if (title) title.textContent = chosen.length ? FAMILY_TITLE : DEFAULT_TITLE;
    if (!tbody) return;
    tbody.querySelectorAll('[data-shcmp-architectural-row="true"]').forEach(r => r.remove());
    if (!modal || modal.hidden || chosen.length < 2) return;
    const coreRows=[...tbody.querySelectorAll('.shcmp-data-row')].filter(r=>r.dataset.shcmpArchitecturalRow!=='true');
    if (coreRows.length) return;
    const onlyDiff=Boolean(root.querySelector('[data-shcmp-differences]')?.checked);
    const html=SCHEMA.map((group,gi)=>{
      const rows=group.rows.map(([path,label])=>{
        const values=chosen.map(p=>getPath(p.profile,path));
        const normalized=values.map(norm).filter(Boolean); const different=new Set(normalized).size>1 || normalized.length!==values.length;
        if (!normalized.length || (onlyDiff && !different)) return '';
        const classes=['shcmp-data-row',path.startsWith('decision.')?'is-guidance':'',path==='decision.soundhous_recommendation'?'is-recommendation':''].filter(Boolean).join(' ');
        return `<tr class="${classes}" data-different="${different?'true':'false'}" data-shcmp-architectural-row="true"><th scope="row" class="shcmp-label">${esc(label)}</th>${values.map(v=>`<td class="shcmp-value">${esc(v ?? '—')}</td>`).join('')}</tr>`;
      }).join('');
      return rows ? `<tr class="shcmp-group-row${gi===0?' shcmp-group-row--guidance':''}" data-shcmp-architectural-row="true"><th colspan="${chosen.length+1}">${esc(group.label)}</th></tr>${rows}` : '';
    }).join('');
    if (html) tbody.insertAdjacentHTML('beforeend',html);
  };

  const bind=(root)=>{
    if (!root || root.dataset.shcmpArchitecturalV1Ready==='true') return;
    root.dataset.shcmpArchitecturalV1Ready='true'; let queued=false;
    const schedule=()=>{ if(queued)return; queued=true; requestAnimationFrame(()=>{queued=false;render(root);}); };
    new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','aria-pressed']});
    root.querySelector('[data-shcmp-differences]')?.addEventListener('change',schedule);
    root.addEventListener('click',schedule); schedule();
  };
  const init=()=>document.querySelectorAll('[data-soundhous-compare-root]').forEach(bind);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init();
  document.addEventListener('shopify:section:load',init);
})();